export default __webpack_public_path__ + "static/media/thailand_covidsation.a7b9cde0.jpg";